import { Listbox } from '@headlessui/react'
import { cx } from './classNames'
import { SelectOptionRow } from './SelectOptionRow'
import type { SelectListboxLayoutProps, SelectOption } from './types'

/**
 * Props for the non-searchable select listbox.
 */
export type SelectOptionsListProps = SelectListboxLayoutProps & {
  options: SelectOption[]
  emphasizePrimaryLabel: boolean
  optionsClassName?: string
}

/**
 * Listbox structure for plain selects.
 */
export const SelectOptionsList = ({
  options,
  emphasizePrimaryLabel,
  optionsClassName,
  style,
  placement,
  optionsRef,
}: SelectOptionsListProps) => (
  <Listbox.Options
    ref={optionsRef}
    as="div"
    style={style}
    className={cx(
      'z-[120] overflow-auto rounded-xl border p-1 text-sm shadow-xl focus:outline-none normal-case',
      placement === 'top' ? 'origin-bottom-left' : 'origin-top-left',
      'border-(--color-border-default,#e2e8f0) bg-(--color-bg-card,#ffffff) text-(--color-text-secondary,#334155)',
      optionsClassName,
    )}
  >
    {options.map((option) => (
      <SelectOptionRow key={option.value} option={option} emphasizePrimaryLabel={emphasizePrimaryLabel} />
    ))}
  </Listbox.Options>
)

